"use client";
import React from "react";
import TopBanner from "./components/TopBanner";
import OurMission from "./components/OurMission";
import WorkflowSteps from "./components/WorkflowSteps";
import BottomBanner from "./components/BottomBanner";

export default function FreelancerWorkflowPage() {
  const freelancerSteps = [
    {
      title: "Create a Professional Profile",
      subtitle: "that Showcases Your Skills",
      description: [
        "Your profile is more than a page  it’s your personal brand. It’s how clients discover your talent, your story, and what makes your work unique.",
        "Add your skills, experience, and a professional photo. Highlight your creativity and achievements through a portfolio that truly reflects your best work.",
        "",
        "A complete profile helps you stand out, attract the right opportunities, and build lasting trust with clients. Take a few moments to tell your story let your skills shine and your work speak for itself"
      ],
      image: "/images/work/create profile.png",
      alt: "Create Profile"
    },
    {
      title: "Find Projects",
      subtitle: "Explore projects that match your strengths and passions.",
      description: [
        "Our smart matching system connects you with clients who need your exact skills  helping you find the right work quickly and effortlessly.",
        "",
        "You can also browse by category, budget, or location to discover the perfect fit.",
        "When you find a project you love, send a personalized proposal that highlights your experience, showcases your best work, and shows clients why you’re the right choice."
      ],
      image: "/images/work/find projects.png",
      alt: "Find Projects"
    },
    {
      title: "Shortlist,",
      subtitle: "Hire and Collaborate with Confidence",
      description: [
        "Review proposals carefully and shortlist freelancers who best fit your project needs.",
        "Compare their experience, ratings, and portfolios to make the right choice for your goals.",
        "",
        "Once you’re ready, start a conversation directly on Hyrelancer to discuss ideas, timelines, and budgets.",
        "After selecting your freelancer, pay a small deposit to begin the project and collaborate seamlessly using our secure tools for chat, file sharing, and milestone tracking.",
        "",
        "When the work is complete and you’re fully satisfied, release payment safely through our protected system simple, transparent, and secure."
      ],
      image: "/images/work/assigned.png",
      alt: "Collaborate"
    }
  ];

  return (
    <div className="w-full relative bg-white overflow-hidden">
      <div className="w-full flex flex-col items-center gap-12 md:gap-20 lg:gap-28">
        {/* Top Banner Section */}
        <TopBanner />

        {/* Our Mission Section */}
        <OurMission />

        {/* Workflow Steps Section */}
        <WorkflowSteps 
          userType="Right freelancer for your need"
          description="Browse freelancers by category or simply post your job and let the right experts reach out to you"
          steps={freelancerSteps}
        />

        {/* Bottom Banner / CTA Section */}
        <BottomBanner />
      </div>
    </div>
  );
}
